import { Container, ContainerProps, GlobalStyles } from '@mui/material';

export interface FullScreenContainerProps extends ContainerProps {
  disablePadding?: boolean;
  transparentBackground?: boolean;
}

export const FullScreenContainer = ({
  disablePadding,
  transparentBackground,
  ...rest
}: FullScreenContainerProps) => (
  <>
    <GlobalStyles
      styles={(theme) => ({
        body: {
          ...(!transparentBackground && {
            backgroundColor: theme.palette.background.paper,
            [theme.breakpoints.up('md')]: {
              backgroundColor: theme.palette.background.default,
            },
          }),
        },
      })}
    />
    <Container
      fixed
      {...rest}
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        py: { sm: 0, md: 8.5, lg: 19 },
        ...(disablePadding
          ? {
              p: { sm: 0 },
            }
          : {
              pt: 2,
              pb: 3,
            }),
        ...rest.sx,
      }}
    />
  </>
);
